
import {
  Component, Ref, Vue, Watch,
} from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SystemtModule from '@/store/SystemModule'
import ViewModel from '@/models/ViewModel'

import Widget from '@/components/Widget/Widget.vue'
import DataTable from '@/components/DataTable/index.vue'
import SearchInput from '@/components/SearchInput/SearchInput.vue'
import IconAction from '@/components/IconAction/IconAction.vue'
import FormInput from '@/components/FormInput/FormInput.vue'
import { currencyMask } from '@/models/interface/Masks'
import DatePicker from '@/components/DatePicker/DatePicker.vue'
import RemoteConnection from '@/models/RemoteConnection'
import remote_connection_fields from './remote_connection_fields'

@Component({
  components: {
    Widget,
    DataTable,
    SearchInput,
    IconAction,
    FormInput,
    DatePicker,
  },
})
export default class RemoteConnectionHome extends ViewModel {
  @Ref() readonly dataTable!: any

  public sort_by: string = 'created_at'

  public sort_desc: boolean = true

  public query: string[] = []

  public page_size: number = 50

  public page: number = 1

  public records: number = 0

  public loading: boolean = false

  public ready: boolean = false

  public fields: any = []

  public show_filter_helper: boolean = false

  public fieldFilters: any = {}

  public query_settings: any = {
    custom_fields: [
      {
        name: 'driver:gam',
        value: 'driver:gam',
        description: 'Filter by drives',
      },
      {
        name: 'driver:freewheel',
        value: 'driver:freewheel',
        description: 'Filter by drives',
      },
      {
        name: 'type:adserver',
        value: 'type:adserver',
        description: 'Filter by type',
      },
      {
        name: 'type:direct_connection',
        value: 'type:direct_connection',
        description: 'Filter by type',
      },
    ],
  }

  public filter_mode: string = 'exclusive'

  @Watch('filter_mode')
  public onFilterModeChange() {
    this.refresh()
  }

  @Watch('fields', { deep: true })
  public onFieldsChange() {
    if (this.ready) {
      this.syncFilters()
    }
  }

  public get masks() {
    return { currency: currencyMask }
  }

  public get show_fields() {
    return this.fields.filter((f: any) => f.show)
  }

  public get active_field_keys() {
    return this.show_fields.map((f: any) => f.key)
  }

  public remoteConnections(context: any) {
    this.loading = true

    const field_filters = Object.keys(this.fieldFilters)
      .filter((key: string) => this.fieldFilters[key] !== '')
      .map((key: string) => `${key}:${this.fieldFilters[key].toLowerCase()}`)

    this.syncFilters()

    return RemoteConnection.paginate({
      page_size: context.perPage,
      page: context.currentPage,
      order_by: context.sortBy,
      order: context.sortDesc ? 'desc' : 'asc',
      query: [...context.filter, ...field_filters],
      mode: this.filter_mode,
    }).then(result => {
      this.records = result.records
      this.loading = false
      return result.data
    })
  }

  public mounted() {
    this.fields = remote_connection_fields

    this.loadFilters()
  }

  public syncFilters() {
    const system = getModule(SystemtModule)
    system.updateState({
      name: 'filters',
      type: 'remote_connection',
      data: { query: this.query, fieldFilters: this.fieldFilters, mode: this.filter_mode },
    })

    system.updateState({
      name: 'fields',
      type: 'remote_connection',
      data: this.active_field_keys,
    })
  }

  public loadFilters() {
    const system = getModule(SystemtModule)
    let promises: Promise<any>[] = []

    const filter = system.getFilter('remote_connection').then((filter: any) => {
      if (filter) {
        this.query = filter.query
        this.fieldFilters = filter.fieldFilters
        this.filter_mode = filter.mode
      }
    })

    const field = system.getFields('remote_connection').then((fields: any) => {
      if (fields) {
        this.fields = this.fields.map((field: any) => {
          field.show = fields.includes(field.key)
          return field
        })
      }
    })

    promises.push(filter)
    promises.push(field)

    Promise.all(promises).then(() => {
      this.ready = true
    })
  }

  public clearFilters() {
    const system = getModule(SystemtModule)
    system.updateState({
      name: 'filters',
      type: 'remote_connection',
      data: null,
    })
  }

  public refresh() {
    this.dataTable.refresh()
  }

  public resetFilters() {
    this.fieldFilters = {
      start_at: '',
      end_at: '',
      created_at: '',
      updated_at: '',
      status: '',
      is_new_business: '',
      quarters: '',
      closed_at: '',
      pitched_at: '',
    }
    this.query = []
    this.filter_mode = 'exclusive'
    this.clearFilters()
    this.refresh()
  }
}
